type Fn = (...args: any[]) => any;

const defaultDelay = 400;
export default class ScrollTracker {
  fn: Fn;
  start: number;
  end: number;
  wait: number;
  el: HTMLElement | Document;
  timeout: any;
  constructor(fn: Fn, el: Document | HTMLElement, delay = defaultDelay) {
    this.fn = fn;
    this.el = el;
    this.wait = delay;
    this.start = 0;
    this.end = 0;
    this.scrollHandle = this.scrollHandle.bind(this);
  }
  register() {
    this.el.addEventListener('scroll', this.scrollHandle);
  }
  revoke() {
    this.el.removeEventListener('scroll', this.scrollHandle);
  }
  scrollHandle() {
    !this.start && (this.start = this.getScrollTop(this.el));
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.end = this.getScrollTop(this.el);
      if (this.start !== this.end) {
        this.callFn();
      }
      this.clearData();
    }, this.wait);
  }
  callFn() {
    this.fn.call(null, this.start, this.end);
  }
  clearData() {
    this.start = 0;
    this.end = 0;
    this.timeout = null;
  }
  getScrollTop(el: Document | HTMLElement) {
    if (el === document) {
      return el.documentElement.scrollTop + el.body.scrollTop;
    }
    return (el as HTMLElement).scrollTop;
  }
}

// 处理滚动埋点
/*
mounted(){
  let el = this.$refs.container
  new ScrollTracker((start,end)=>{
    track('event',payload)
  },el)
}
*/
